<template>
  <div class="layout" id="firstPage">
    <Layout>
      <Sider ref="side1" hide-trigger collapsible :collapsed-width="78" width="220">

        <Menu
          :active-name="activeMenu"
          :open-names="openNames"
          theme="dark"
          width="220"
          @on-select="menuSelect"
          accordion
          ref="leftMenu"
          class="menuBox"
        >
          <template v-for="(menu, i) in menus">
            <MenuItem :name="menu.code" :key="menu.code" v-if="menu.url != '#'">
              <!-- #8C8D91 -->

              <span
                class="iconfont iconshouye-weixuanzhong1"
                style="margin-left: -14px"
                v-if="menu.code == 'index'"
              ></span>
              <span
                class="iconfont iconqiancezhanchang"
                style="margin-left: -14px; top: -1px; font-size: 12px"
                v-if="menu.code == 'other'"
              ></span>
              <span class="iconfont" :class="menu.ico" style="margin-left: -25px" v-else-if="menu.ico"></span>
              {{ menu.name }}
            </MenuItem>
            <Submenu :name="menu.code" :key="menu.code" v-else>
              <template slot="title">
                <template>
                  <span class="iconfont" :class="menu.ico" v-if="menu.ico"></span>
                </template>
                {{ menu.name }}
              </template>
              <template v-if="menu.children">
                <div v-for="child in menu.children" :key="child.code">
                  <MenuItem v-if="child.url != '#'" :name="child.code" class="item-level2">
                    {{ child.name }}
                  </MenuItem>
                  <Submenu :name="child.code" v-else class="title-level2">
                    <div slot="title">
                      <span class="iconfont" :class="child.ico" v-if="child.ico"></span>
                      {{ child.name }}
                    </div>
                    <template v-if="child.children">
                      <MenuItem :name="child2.code" v-for="child2 in child.children" :key="child2.code" class="level3">
                        {{ child2.name }}
                      </MenuItem>
                    </template>
                  </Submenu>
                </div>
              </template>
            </Submenu>
          </template>
        </Menu>
      </Sider>
      <Layout>
        <Content>
          <div class="picTaps">
            <!-- 顶部 -->
            <div class="nav clearfix">
              <div class="left" style="float: left">
                <Breadcrumb separator="<i class='ivu-icon ivu-icon-ios-arrow-forward'></i>">
                  <BreadcrumbItem
                    @click.native="toggNav(item, index, navList)"
                    v-for="(item, index) in navList"
                    :key="index"
                    >{{ item && item.name }}</BreadcrumbItem
                  >
                </Breadcrumb>
              </div>
              <div class="right clearfix" style="position: relative">
                <div class="userBox clearfix" style="float: right">
                  <div class="slider-top topMoves">
                    <Dropdown
                      trigger="click"
                      transfer-class-name="slider-top-drop"
                    >
                      <!--  -->
                      <a href="javascript:void(0)">
                        <span>{{ userName }}</span>
                        <Icon type="ios-arrow-down" />
                        <span class="company">{{ organizationName }}</span>
                      </a>

                      <DropdownMenu slot="list">
                        <DropdownItem @click.native="cPassword"
                          >账户设置</DropdownItem
                        >
                        <DropdownItem @click.native="outLogin"
                          >退出登录</DropdownItem
                        >
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </div>
            <tag-list @openPage="openPage" @refreshLeftMenu='refreshLeftMenu'></tag-list>
          </div>
          <!--          <router-view></router-view>-->
          <iframe
            class="iframeDom"
            :src="iframeUrl"
            frameborder="0"
            ref="iframe"
            id="iframe"
          ></iframe>
        </Content>
      </Layout>
    </Layout>
    <!-- 账户设置 -->
    <accountSettings ref="accountSettings" />
  </div>
</template>
<script>
//当前实例组件
import _ from "lodash";
let vm = "";
import myForm from "@/components/commons/form";
import tagList from "@/components/system/tagList";
import accountSettings from './components/accountSettings';
export default {
  data() {
    return {
      userType: "",
      curTop: 0,
      organizationName: "",
      formDateAddServer: [],
      navList: [],
      curUrl: "",
      iframeUrl:"",
      delayerMenu: [],
      openNames: [],
      userName: "",
      menus: [],
      right_taps: [],
      activeMenu: "",
    };
  },
  computed: {

    currentUrl() {
      const res = this.delayerMenu.find(
        (item) => item.code === this.activeMenu
      );
      let url = "";
      if (res) {
        this.curUrl = res;
        url = res.url;
      } else {
        if (this.delayerMenu.find((item) => item.url == "/home")) {
          url = "/home";
        } else {
          if (this.delayerMenu[0] && this.delayerMenu[0].url != '#') {
            url = this.delayerMenu[0].url;
          }else if (this.delayerMenu[1] && this.delayerMenu[1].url != '#') {
            url = this.delayerMenu[1].url;
          }
        }
      }
      if(url){
        if(!this.iframeUrl){
          this.iframeUrl = url;
        }
      }
      return url;

    },
  },
  components: {
    accountSettings,
    myForm,
    tagList
  },
  async created() {
    let basePass = localStorage.basePass;
    if (basePass) {
      basePass = JSON.parse(basePass);
      this.formInline = basePass;
    }
    await this.getDicAll();
    await this.getUserInfo();
    this.getList();
  },
  mounted() {
    vm = this;
    //监听iframe传过来的信息
    window.addEventListener("message", (e) => {
      if (!e.data.appMessage) {
        return;
      }
      if (e.data.nav) {
        if (e.data.nav.length > 0 && this.delayerMenu.length > 0) {
          this.navList = e.data.nav;
        } else {
          this.navList = [
            {
              name: "首页",
              path: "/home/index",
            },
          ];
        }
        const title = this.navList.slice(-1)[0].name;
        document.title = title + "-精誠業務支持系統";
      }
      if (e.data.updateNav) {
        const url = e.data.parentUrl || e.data.updateNav;//若为子路由 左侧菜单取父路由

        if (url === "/") {
          this.printLog("index");
        } else {
          const cur = this.delayerMenu.find((its) => url === its.url);
          if (cur) {
            this.printLog(cur.code);
          }
        }
      }
    });

    //
  },
  methods: {
    // 缓存字典数据
    getDicAll(){
      return this.$http({
        type: 'POST',
        url: '/system/dic/list',
        data: {}
      }).then((res) => {
        const dicData = res.data;
        const dic = {};
        for (const key in dicData) {
          if (Object.hasOwnProperty.call(dicData, key)) {
            const list = dicData[key].map(item =>({
              value: item.value,
              txt: item.txt,
            }));
            dic[key] = {};
            list.forEach(item=>{
              dic[key][item.value] = item.txt;
            })
          }
        }
        localStorage.dic = JSON.stringify(dic);// map结构数据
        localStorage.dicData = JSON.stringify(dicData);// list结构数据
      })
    },

    toggleNews() {
      this.$refs.iframe.contentWindow.postMessage({ toggleNews: 1 }, "*");
    },
    refreshLeftMenu(leftMenuUrl){
      let code = this.delayerMenu.find(i => i.url == leftMenuUrl).code;
      this.activeMenu = code;
    },
    openPage(url){
      this.$refs.iframe.contentWindow.postMessage({ refreshPageUrl: url }, "*");
    },
    //切换面包屑
    toggNav(item, index, arr) {
      if (item.noclick) {
        return;
      }
      if (arr.length === index + 1) return;
      if (index != 0) {
        const url = item.path;
        const cur = this.delayerMenu.find((its) => its.url == item.path);
        if (cur) {
          window.iframe.contentWindow.postMessage({ refreshPageUrl: url }, "*");
          sessionStorage.setItem("currentActiveMenu", cur.code);
        } else {
          history.go(-1);
        }
      } else {
        //首页
        sessionStorage.setItem("currentActiveMenu", "index");
      }
    },
    //扁平化数据
    arrDelayering(arr) {
      // 树形 => 扁平化
      let result = [];
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        var res = JSON.parse(JSON.stringify(item)); // 先克隆一份数据作为第一层级的填充
        delete res["children"];
        result.push(res);
        if (item.children instanceof Array && item.children.length > 0) {
          // 如果当前child为数组并且长度大于0，才可进入flag()方法
          result = result.concat(this.arrDelayering(item.children));
        }
      }
      return result;
    },
    // 打开账户设置
    async cPassword() {
      this.$refs.accountSettings.open();
    },
    getUserInfo() {
      return this.$http({
        type: "get",
        url: "/system/info/userinfo",
      }).then((res) => {
        this.getMenuTokenList(res.data);
        // if (!res.data.mobile) {
        //   //强制退出登录
        //   this.outLogin();
        // }
        //水印
        //this.$units.waterMark(res.data.userName)
        this.userType = res.data.userType;

        this.userName = res.data.fuzzUserName;
        localStorage.setItem("userInfo", JSON.stringify(res.data));
        this.organizationName = res.data.organizationName;

        return this.$http({
          url: '/buz/merchant/curr/detail',
          type: 'POST',
          data: {}
        }).then(res => {
          // 获取当前账号的vip等级
          sessionStorage.setItem('__vipLevel__', res.data.vipLevel)
        });
      });
    },
    refresh() {
      document.getElementById("iframe").contentWindow.location.reload(true);
    },
    getMenuTokenList(data) {
      this.$http({
        type: "GET",
        url: `/buz/rolesExt/menuPerms/${data.userid}`
      })
        .then(res => {
          localStorage.setItem("ACTION_BUTTON_TOKEN", JSON.stringify(this.treeList(res.data)));
          // console.log(this.$units.pointAction('org_2_01'));
        }).catch((err) => {
          localStorage.setItem("ACTION_BUTTON_TOKEN", '[]');
        });
    },
    treeList(arr) {
      let data = JSON.parse(JSON.stringify(arr)); // 对传入的参数进行深拷贝
        let newData = []; // 创建空数组用来接收操作后的新数组
        let newArr=[];
        const hasChildren = item => {
            // 递归遍历，把包含children的选项拿出来，push到之前新建的空数组内
            (item.childs || (item.childs = [])).map(v => {
                hasChildren(v);
            });
            delete item.childs; // 删除原children属性，可选项
            newData.push(item);
        };
        data.map(v => hasChildren(v));
        newData.map(item=>{
          if(item.perms){
            newArr = [...newArr, ...item.perms]
          }
        })
        return newArr;
    },
    getList() {
      this.$http({
        type: "get",
        url: "/system/sysMenus2/readByUser",
      })
        .then((data) => {
          let menus = data.data.children;
          menus = this.checkMenuAuth(menus);
          this.menus = menus;
          this.delayerMenu = this.arrDelayering(this.menus);
          this.activeMenu = sessionStorage.getItem("currentActiveMenu");
          this.$nextTick(() => {
            this.$refs.leftMenu.updateActiveName();
          });
        })
    },
    // 验证菜单权限，删除无权限菜单
    checkMenuAuth(menus) {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      const delArr = [];
      if(userInfo.showCommission == '0') {
        delArr.push('activityCenter', 't_fee', 't_settlement');
      }
      menus = menus.filter(item =>{
        menus.children = item.children.filter(item => {
          return !delArr.includes(item.code);
        });
        return !delArr.includes(item.code);
      })
      return menus
    },
    // 选择菜单
    menuSelect(e) {
      // if (e == "index") {
      //   sessionStorage.setItem("currentActiveMenu", "index");
      //   // window.location.reload();
      //   // this.$refs.leftMenu.updateActiveName();
      //   return;
      // }
      this.activeMenu = "";
      this.$nextTick(() => {
        sessionStorage.setItem("currentActiveMenu", e);

        this.activeMenu = sessionStorage.getItem("currentActiveMenu");
        this.openPage(this.currentUrl);
        this.$nextTick(() => {
          this.$refs.leftMenu.updateActiveName();
          //获取激活导航定位位置
          setTimeout(() => {
            this.curTop = document
              .querySelector(".ivu-menu-item-selected")
              .getBoundingClientRect().top;
          }, 180);
        });
        let menu = this.getMenuData(e, this.menus);
        if (this.checkTapDuplication(menu) > -1) {
        } else {
          this.right_taps.push({
            name: menu.name,
            code: menu.code,
            url: menu.url,
          });
          // if (this.right_taps.length > 10) {
          //   this.right_taps.shift();
          // }
        }
      });
    },
    togglePage(url) {
      this.menuSelect(url);
    },
    // 校验去重
    checkTapDuplication(d) {
      let index = _.findIndex(this.right_taps, (item) => {
        return item.code == d.code;
      });
      return index;
    },
    getMenuData(e, data) {
      let result = null;
      for (let k = 0; k < data.length; k++) {
        if (data[k].code == e) {
          result = data[k];
          break;
        }
        let child = data[k].children;
        if (child && child.length > 0) {
          let childRe = this.getMenuData(e, child);
          if (childRe) {
            result = childRe;
            break;
          }
        }
      }
      return result;
    },
    // 退出登录
    outLogin() {
      this.$http({
        type: "get",
        url: "/system/info/logout",
      }).then((data) => {
        localStorage.removeItem("hasLogin");
        this.$units.goLogin();
      });
    },
    //节流
    printLog: _.throttle((currentActiveMenu) => {
      if (vm) {
        sessionStorage.setItem("currentActiveMenu", currentActiveMenu);
        vm.activeMenu = currentActiveMenu;
        vm.$nextTick(() => {
          vm.$refs.leftMenu && vm.$refs.leftMenu.updateActiveName();
        });
      }
    }, 1000),

  },
  watch: {
    currentUrl() {},
    activeMenu(newVal) {
      if (!newVal) {
        return;
      }
      const names = newVal.split("_")
      if(names.length==3){
        this.openNames = [names[0],names[0]+'_'+names[1]]
      }else{
        this.openNames = [names[0]]
      }
      if (newVal && newVal != "0") {
        this.$nextTick(() => {
          this.$refs.leftMenu.updateOpened();
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
